module.exports = __webpack_public_path__ + "img/EAS_MaddenNFL21_Primary_1Color_Horizontal_White.9ce16291.png";